module.exports = __webpack_public_path__ + "static/media/room.89cabf49.gif";